// src/lib/mediaUrl.js
export function resolveMediaUrl(url) {
  if (!url) return '';
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:')) return url;
  // Seeded public assets:
  if (url.startsWith('/img/')) return `${process.env.PUBLIC_URL || ''}${url}`;
  return url;
}
